import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import SubscriptionWarningBanner from '../SubscriptionWarningBanner';
import ModuleRouteGuard from '../ModuleRouteGuard';
import { useAuth } from '@/context/AuthContext';
import { useSubscription } from '@/context/SubscriptionContext';

const Layout = ({ children, tenantCode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const { user } = useAuth();
  const { subscriptionStatus, isExpired, isGracePeriod, daysRemaining } = useSubscription();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleRenew = () => {
    window.location.href = '/purchase';
  };

  const handleDismissBanner = () => {
    setBannerDismissed(true);
    // Remember dismissal for this session
    sessionStorage.setItem('subscription_banner_dismissed', 'true');
  };

  // Check if banner was dismissed this session
  useEffect(() => {
    const dismissed = sessionStorage.getItem('subscription_banner_dismissed');
    if (dismissed) setBannerDismissed(true);
  }, []);

  // Show banner for expired, grace period, or expiring soon (7 days)
  const shouldShowBanner = user?.role === 'Admin' && !bannerDismissed && subscriptionStatus && (
    isExpired || isGracePeriod || (daysRemaining !== null && daysRemaining <= 7)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} tenantCode={tenantCode} />
      
      <div className="lg:ml-64 flex flex-col min-h-screen">
        {/* Subscription Warning Banner - Only for Admin */}
        {shouldShowBanner && (
          <SubscriptionWarningBanner 
            subscriptionStatus={subscriptionStatus}
            onRenew={handleRenew}
            onDismiss={!isExpired ? handleDismissBanner : null}
          />
        )}
        
        <Header toggleSidebar={toggleSidebar} />
        
        <main className="flex-1 p-6">
          <ModuleRouteGuard tenantCode={tenantCode}>
            {children}
          </ModuleRouteGuard>
        </main>
        
        <Footer variant="default" />
      </div>
    </div>
  );
};

export default Layout;
